import { render, staticRenderFns } from "./BankSetting.vue?vue&type=template&id=526f5737&scoped=true"
import script from "./BankSetting.vue?vue&type=script&lang=js"
export * from "./BankSetting.vue?vue&type=script&lang=js"
import style0 from "./BankSetting.vue?vue&type=style&index=0&id=526f5737&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f5737",
  null
  
)

export default component.exports